module.exports = __webpack_public_path__ + "static/img/bg_yh.a633399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_yh.jpg
// module id = Ni9l
// module chunks = 1